import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { ComponentsComponent } from './components/components.component';
import { ProfileComponent } from './examples/profile/profile.component';
import { SignupComponent } from './examples/signup/signup.component';
import { LandingComponent } from './examples/landing/landing.component';
import { NucleoiconsComponent } from './components/nucleoicons/nucleoicons.component';
import { BlogComponent } from './components/blog/blog.component';
// import { JeparticipeComponent } from './components/jeparticipe/jeparticipe.component';

const routes: Routes =[
    { path: '',                 component: ComponentsComponent },
    { path: 'home',             component: ComponentsComponent },
    // { path: 'jeparticipe',      component: JeparticipeComponent },
    { path: 'user-profile',     component: ProfileComponent },
    { path: 'blog',             component: BlogComponent },
    { path: 'signup',           component: SignupComponent },
    { path: 'landing',          component: LandingComponent },
    { path: 'nucleoicons',      component: NucleoiconsComponent }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes)
  ],
  exports: [ RouterModule
  ],
})
export class AppRoutingModule { }
